import React from "react"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Reactmarkdown from "react-markdown"
import { Carousel } from 'react-responsive-carousel'

import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = ( {data} ) => {
  const qry = data.allStrapiHomepage.edges[0].node;


  return (
    <Layout>
    <SEO title="Willkommen" />
      <div className="header-nav">
        <ul>
          <li style={{ opacity: "0" }}>&nbsp;</li>
        </ul>
      </div>
 
      <Carousel infiniteLoop={true} autoPlay={true} showThumbs={true} interval={5000} showStatus={false} showArrows={true} className="heroimage">
        { qry.images.map((node, index) => (
          <div key={index}>
            <Img fluid={ node.localFile.childImageSharp.fluid  } />
          </div>
        ))}        
      </Carousel>

      <Reactmarkdown>{ qry.content }</Reactmarkdown>

  </Layout>
  )
}


export default IndexPage

export const query = graphql`
  query HomepageQuery {
    allStrapiHomepage {
      edges {
        node {
          content
          images {
            localFile {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          } 
        }
      }
    }
  }
`